import EmberRouter from '@ember/routing/router';
import config from 'beebeeboard-booking/config/environment';
import { setupRouterTracking } from 'beebee-base/lib/router-tracking';
import { inject as service } from '@ember/service';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;

  @service router;

  constructor() {
    super(...arguments);
    setupRouterTracking(this, {
      gaId: 'G-Q4R8QL4WC0',
      stripToken: true,
      pushDataLayer: true,
      scrollSelector: 'html, body',
      scrollDuration: 50,
      dropdownCleanup: false,
    });
  }
}

Router.map(function () {
  this.route('checkin');
  this.route('form');
  this.route('confirm');
  this.route('user');
  this.route('token_login', { path: '/token_login/:state/:token' });
  this.route('use_voucher');
  this.route('guide_personal_data');
  this.route('heliguides_personal_data');
  this.route('heliguides_sign_request');
  this.route('sciclub');
  this.route('vouchers');
  this.route('payment_status', { path: '/payment_status/:payment_id' });
});
